import "./service.css"
import { useScroll, motion, useSpring, useTransform } from "motion/react";
import { useEffect, useState } from "react";
import PopForm from "../components/popForm";

export default function ServiceAssociate(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const {scrollY} = useScroll()
    const rotate = useTransform(
      scrollY,
      [0, 300],
      [0, 310],
      { clamp: false }
    )

    const [pop, setPop] = useState(sessionStorage.getItem('pop'))
    const closePop = ()=>{
      sessionStorage.setItem('pop', true);
      setPop(true)
    }
    return(
        <>
        <section className="container serviceLanding">
            <h2>Other<br/> Services</h2>        
        </section>
        <div className="wrapper">
            <section className="container serviceContainer">
                <header>
                    <figure className="serviceFlower">
                        <img src="../images/flower_2.png" alt="flower"/>
                    </figure>
                    <h3>Aurum Associates</h3>
                    <p>offers instant spot cash for gold, silver, or diamond jewelry. Selling gold is easy and fast, visit our nearest branch to avail the best price for your gold now.</p>
                </header>
                <main>
                    <div className="service">
                        <h3>Home Loan</h3>
                        <figure>
                            <img src="../images/Home.png" alt="Home"/>
                        </figure>
                        <p>Aurum Associates helps you finance your dream home with ease. Our home loans come with competitive interest rates and flexible repayment options to make home ownership a reality.</p>
                    </div>

                    <div className="service">
                        <h3>Mortgage Loan</h3>
                        <figure>
                            <img src="../images/Mortgage.png" alt="Mortgage"/>
                        </figure>
                        <p>With Aurum Associates, you can unlock the potential of your property through our mortgage loans. Secure funds for any purpose by using your property as collateral.</p>
                    </div>

                    <div className="service">
                        <h3>Loan Against Property</h3>
                        <figure>
                            <img src="../images/Property.png" alt="Property"/>
                        </figure>
                        <p>Aurum Associates offers loans against residential, commercial, or industrial properties. Benefit from a smooth process and attractive interest rates to achieve your financial goals.</p>
                    </div>

                    <div className="service">
                        <h3>Business Loan</h3>
                        <figure>
                            <img src="../images/Business.png" alt="Business"/>
                        </figure>
                        <p>Grow your business with Aurum Associates’ tailored business loan solutions. Whether you need funds for expansion, equipment, or operations, we’ve got you covered.</p>
                    </div>

                    <div className="service">
                        <h3>Personal Loan</h3>
                        <figure>
                            <img src="../images/Personal.png" alt="Personal"/>
                        </figure>
                        <p>Meet your urgent financial needs with Aurum Associates’ personal loans. Enjoy quick approvals, minimal documentation, and flexible terms for your convenience.</p>
                    </div>

                    <div className="service">
                        <h3>Vehicle Loan</h3>
                        <figure>
                            <img src="../images/Vehicle.png" alt="Vehicle"/>
                        </figure>
                        <p>Drive your dream vehicle with Aurum Associates' vehicle loan services. We offer affordable rates and flexible repayment options for cars, bikes, and commercial vehicles.</p>
                    </div>

                    <figure className="serviceDecor_1">
                        <motion.img
                        id="scroll-indicator"
                        style={{
                            rotate
                        }}
                        src="../images/shape_1.png" alt="shape"/>
                    </figure>
                </main>
            </section>
        </div>
        {pop?null:<PopForm close={closePop}/>}
        </>
    )
}